export default "__VITE_ASSET__309f29b6__"